import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuantityModule } from '@shared/core/components/quantity';
import { ButtonsModule } from '@shared/core/components/buttons';
import { TwoColumnsModule } from '@shared/core/components/twoColumns';

import { ModalItemActionsComponent } from './modal-item-actions.shared.component';

@NgModule({
    declarations: [
        ModalItemActionsComponent
    ],
    imports: [
        CommonModule,
        QuantityModule,
        ButtonsModule,
        TwoColumnsModule,
    ],
    exports: [
        ModalItemActionsComponent
    ],
    providers: [],
})
export class ModalItemsActionsModule { }
